import { connect } from 'react-redux';
import { compose, withHandlers, withProps, withState } from 'recompose';
import { getShopBrandId, getUserUrlPrefix, isBrandViewActive } from '../../../auth/selectors';
import withPermissions from '../../../auth/utils/withPermissions';
import { canUserModifyStaffManagement } from '../../../common/helpers/users';
import { createStaffMember } from '../actions';
import { prepareApiUpdate } from './helpers';

import StaffForm from './StaffFormContainer';
import { USER_TYPES } from '../../../auth/constants';
import withNotifications from '../../../common/withNotifications';
import withUnsavedChangesCheck, { withGoToUrl } from './withUnsavedChangesCheck';
import { getNewStaffPermissions } from './permissions/helpers';

export const getInitialValues = (userKind, currentUserPermissions) => ({
  kind: userKind,
  permissions: getNewStaffPermissions(currentUserPermissions),
  trackEmployeeTime: false,
  permissionPasscodeRequired: false,
  enabled: true,
  isTmpPassword: true,
});


const enhance = compose(
  connect(state => ({
    brandId: getShopBrandId(state),
    baseUrl: `${getUserUrlPrefix(state)}/staff`,
    initialUserKind: isBrandViewActive(state) ? USER_TYPES.brand.toString() : USER_TYPES.shop.toString(),
  })),
  withPermissions,
  withNotifications,
  withState('staffUser', 'setStaffUser', null),
  withProps(props => ({
    initialValues: getInitialValues(props.initialUserKind, props.permissions),
    canModifyStaff: canUserModifyStaffManagement(props.permissions),
    edit: false,
  })),
  withState('busy', 'setBusy', false),
  withGoToUrl,
  withHandlers({
    onSubmit: props => (data) => {
      props.setBusy(true);
      const update = prepareApiUpdate(data, props.brandId);
      createStaffMember(props.brandId, update)
        .then((user) => {
          props.addNotification({
            title: 'Success',
            level: 'success',
            message: 'User created. Check top of screen for temporary password.',
          });

          props.goToUrl({
            pathname: `${props.baseUrl}/${user.id}`,
            state: {
              tmpPassword: user.password,
            },
          });
        })
        .catch(() => {
          props.setBusy(false);
        });
    },
  }),
  withUnsavedChangesCheck,
);

export default enhance(StaffForm);
